import {
  CashFlowExpenseAccount,
  CashFlowExpenseByDate,
  CashFlowExpenseFare,
  CashFlowExpenseSalary,
  CashFlowExpenseSubReport,
  CashFlowIncomeBankAccount,
  CashFlowIncomeOwner,
  ChangeCashFlowIncomeSelling,
} from '../components';

export enum TypeTemplates {
  CashFlowIncomeOwner = 0,
  ChangeCashFlowIncomeSelling = 1,
  CashFlowIncomeBankAccount = 2,
  CashFlowExpenseByDate = 3,
  CashFlowExpenseFare = 4,
  CashFlowExpenseSubReport = 5,
  CashFlowExpenseAccount = 6,
  CashFlowExpenseSalary = 7,
}

export const TYPE_TEMPLATE_COMPONENTS = {
  [TypeTemplates.CashFlowIncomeBankAccount]: {
    template: CashFlowIncomeBankAccount,
    claims: ['all'],
  },
  [TypeTemplates.ChangeCashFlowIncomeSelling]: {
    template: ChangeCashFlowIncomeSelling,
    claims: ['all'],
  },
  [TypeTemplates.CashFlowIncomeOwner]: {
    template: CashFlowIncomeOwner,
    claims: ['all'],
  },
  [TypeTemplates.CashFlowExpenseByDate]: {
    template: CashFlowExpenseByDate,
    claims: ['all'],
  },
  [TypeTemplates.CashFlowExpenseFare]: {
    template: CashFlowExpenseFare,
    claims: ['all'],
  },
  [TypeTemplates.CashFlowExpenseSubReport]: {
    template: CashFlowExpenseSubReport,
    claims: ['all'],
  },
  [TypeTemplates.CashFlowExpenseAccount]: {
    template: CashFlowExpenseAccount,
    claims: ['all'],
  },
  [TypeTemplates.CashFlowExpenseSalary]: {
    template: CashFlowExpenseSalary,
    claims: ['CanLookSalaryDetails'],
  },
};
